export default __webpack_public_path__ + "static/media/ADA-BUSD.f697a5b5.png";